import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { delay, filter, map, withLatestFrom } from 'rxjs/operators';
import {
  LocationChangeAction,
  LOCATION_CHANGE,
  replace,
} from 'connected-react-router';
import AppState from '@webapp/store/state';

export const redirectToArtistProfileEpic = (
  action$: Observable<LocationChangeAction>,
  state$: Observable<AppState>
) =>
  action$.pipe(
    ofType<LocationChangeAction>(LOCATION_CHANGE),
    withLatestFrom(state$),
    filter(
      ([_, state]) => state.router.location.pathname === '/artist/tracpage'
    ),
    delay(100),
    map(() => {
      return replace('/artist/profile');
    })
  );
